"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = observeEachEffect;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _createPromiseQueue = _interopRequireDefault(require("../../createPromiseQueue"));

function observeEachEffect(observable, saga) {
  return (0, _effects.call)( /*#__PURE__*/_regenerator["default"].mark(function observeEach() {
    var queue, subscription, result;
    return _regenerator["default"].wrap(function observeEach$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queue = (0, _createPromiseQueue["default"])();
            subscription = observable.subscribe({
              next: queue.push
            });
            _context.prev = 2;

          case 3:
            _context.next = 5;
            return (0, _effects.call)(queue.shift);

          case 5:
            result = _context.sent;
            _context.next = 8;
            return (0, _effects.call)(saga, result);

          case 8:
            _context.next = 3;
            break;

          case 10:
            _context.prev = 10;
            subscription.unsubscribe();
            return _context.finish(10);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, observeEach, null, [[2,, 10, 13]]);
  }));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJvYnNlcnZlRWFjaEVmZmVjdCIsIm9ic2VydmFibGUiLCJzYWdhIiwiY2FsbCIsIm9ic2VydmVFYWNoIiwicXVldWUiLCJjcmVhdGVQcm9taXNlUXVldWUiLCJzdWJzY3JpcHRpb24iLCJzdWJzY3JpYmUiLCJuZXh0IiwicHVzaCIsInNoaWZ0IiwicmVzdWx0IiwidW5zdWJzY3JpYmUiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2FnYXMvZWZmZWN0cy9vYnNlcnZlRWFjaC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjYWxsIH0gZnJvbSAncmVkdXgtc2FnYS9lZmZlY3RzJztcblxuaW1wb3J0IGNyZWF0ZVByb21pc2VRdWV1ZSBmcm9tICcuLi8uLi9jcmVhdGVQcm9taXNlUXVldWUnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBvYnNlcnZlRWFjaEVmZmVjdChvYnNlcnZhYmxlLCBzYWdhKSB7XG4gIHJldHVybiBjYWxsKGZ1bmN0aW9uKiBvYnNlcnZlRWFjaCgpIHtcbiAgICBjb25zdCBxdWV1ZSA9IGNyZWF0ZVByb21pc2VRdWV1ZSgpO1xuICAgIGNvbnN0IHN1YnNjcmlwdGlvbiA9IG9ic2VydmFibGUuc3Vic2NyaWJlKHsgbmV4dDogcXVldWUucHVzaCB9KTtcblxuICAgIHRyeSB7XG4gICAgICBmb3IgKDs7KSB7XG4gICAgICAgIGNvbnN0IHJlc3VsdCA9IHlpZWxkIGNhbGwocXVldWUuc2hpZnQpO1xuXG4gICAgICAgIHlpZWxkIGNhbGwoc2FnYSwgcmVzdWx0KTtcbiAgICAgIH1cbiAgICB9IGZpbmFsbHkge1xuICAgICAgc3Vic2NyaXB0aW9uLnVuc3Vic2NyaWJlKCk7XG4gICAgfVxuICB9KTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQTs7QUFFQTs7QUFFZSxTQUFTQSxpQkFBVCxDQUEyQkMsVUFBM0IsRUFBdUNDLElBQXZDLEVBQTZDO0VBQzFELE9BQU8sSUFBQUMsYUFBQSw2Q0FBSyxTQUFVQyxXQUFWO0lBQUE7SUFBQTtNQUFBO1FBQUE7VUFBQTtZQUNKQyxLQURJLEdBQ0ksSUFBQUMsOEJBQUEsR0FESjtZQUVKQyxZQUZJLEdBRVdOLFVBQVUsQ0FBQ08sU0FBWCxDQUFxQjtjQUFFQyxJQUFJLEVBQUVKLEtBQUssQ0FBQ0s7WUFBZCxDQUFyQixDQUZYO1lBQUE7O1VBQUE7WUFBQTtZQU1TLE9BQU0sSUFBQVAsYUFBQSxFQUFLRSxLQUFLLENBQUNNLEtBQVgsQ0FBTjs7VUFOVDtZQU1BQyxNQU5BO1lBQUE7WUFRTixPQUFNLElBQUFULGFBQUEsRUFBS0QsSUFBTCxFQUFXVSxNQUFYLENBQU47O1VBUk07WUFBQTtZQUFBOztVQUFBO1lBQUE7WUFXUkwsWUFBWSxDQUFDTSxXQUFiO1lBWFE7O1VBQUE7VUFBQTtZQUFBO1FBQUE7TUFBQTtJQUFBLEdBQVVULFdBQVY7RUFBQSxDQUFMLEVBQVA7QUFjRCJ9